import { ISoccerCommentaryMessage } from "../../../../../types";
import { LiveCommentaryMessage } from "./LiveCommentaryMessage";

export function CommentaryBody({
  isExpanded,
  isLoading,
  isEmpty,
  topMessage,
  feed,
  noDataText,
}: {
  isExpanded: boolean;
  isLoading: boolean;
  isEmpty: boolean;
  topMessage: ISoccerCommentaryMessage;
  feed: ISoccerCommentaryMessage[];
  noDataText: string;
}) {
  if (isLoading) {
    return <p className="commentary-placeholder">Loading...</p>;
  }

  if (isEmpty) {
    return <p className="commentary-placeholder">{noDataText}</p>;
  }

  return (
    <div className={`commentary-body ${isExpanded ? "expanded" : "collapsed"}`}>
      {isExpanded ? (
        feed.map((msg) => <LiveCommentaryMessage key={msg.id} message={msg} />)
      ) : (
        <LiveCommentaryMessage message={topMessage} />
      )}
    </div>
  );
}
